import { useParams } from "react-router-dom";

export default function useCourseId(): string {
  const { courseId } = useParams() as any;

  if (!courseId) {
    throw new Error(
      `Unable to pull courseId from the current url: ${window.location.pathname}. Have you called this under a Route with a :courseId defined in it's path?`
    );
  }

  return courseId;
}
